import React, {useEffect, useState} from "react";
import {useAppContext} from "../libs/contextLib";
import {PortfolioPublicTable} from "../components/Portfolio/PortfolioPublicTable";
import PortfolioService from "../services/PortfolioService";
import {useLocation} from "react-router-dom";
import Loader from "../components/ui/Loader";
import UserService from "../services/UserService";
import LoaderButton from "../components/loaderButton";
import {retrieveUser} from "../libs/getUsername";
import Web3 from 'web3';

export default function PortfolioPublic() {
    const {isAuthenticated, authenticatedUser} = useAppContext();
    const {pathname, search} = useLocation();
    const [dataRows, setDataRows] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const [errorStatus, setErrorStatus] = useState(200);
    const [isLoading, setIsLoading] = useState(false);
    const [isBtnLoading, setIsBtnLoading] = useState(false);
    const [followedUser, setFollowedUser] = useState("");
    const [emailFriend, setEmailFriend] = useState("")
    const [isEmailLoading, setIsEmailLoading] = useState(false);
    const [addErrorMsg, setAddErrorMsg] = useState("")
    const urlParams = new URLSearchParams(search);

    useEffect(() => {
        async function fetchData() {

            if (urlParams && urlParams.get("followed") !== null) {
                setFollowedUser(urlParams.get("followed"));
                await getPublicPortfolio(urlParams.get("followed"));
            }
        }

        console.log(search);
        setIsLoading(true);
        fetchData();


    }, []);

    async function getPublicPortfolio(followed) {

        if (authenticatedUser.username) {
            const username = authenticatedUser.username;
            console.log("username", username);
            console.log("followed", followed);
            await PortfolioService.getPublicPortfolio(username, followed)
                .then(r => {
                        setDataRows(r);
                        setErrorMessage('');
                        setErrorStatus(200);
                    }
                )
                .catch(e => {
                    if (e.response != null && e.response.status === 404) {
                        console.log(e.message);
                        setErrorMessage(`${followed} didn't upload a portfolio yet.`);
                        setErrorStatus(e.response.status);
                    } else {
                        setErrorMessage("This user is not part of your friends or you didn't subscribe to it.");
                        setErrorStatus(403);
                    }
                    setDataRows([]);
                });
        }

        setIsLoading(false);
    }



    async function subscribe() {

        if (authenticatedUser.username && followedUser) {
            setIsBtnLoading(true);
            await UserService.subscribe(authenticatedUser.username, followedUser)
                .then(r => {
                        getPublicPortfolio(followedUser);
                    }
                )
                .catch(e => {
                    if (e.response != null && e.response.status !== 404) {
                        console.log(e.message);
                        setErrorMessage("Error subscribing, please try again");
                    }
                });
        }

        setIsBtnLoading(false);
    }

    async function unsubscribe() {

        if (authenticatedUser.username && followedUser) {
            setIsBtnLoading(true);
            await UserService.unsubscribe(authenticatedUser.username, followedUser)
                .then(r => {
                        getPublicPortfolio(followedUser);
                    }
                )
                .catch(e => {
                    if (e.response != null && e.response.status !== 404) {
                        console.log(e.message);
                        setErrorMessage("Error unsubscribing, please try again");
                    }
                });
        }

        setIsBtnLoading(false);
    }

    const handleAddFriend = async(event) => {
        event.preventDefault();
        setIsEmailLoading(true);
        if (authenticatedUser.username) {
            const user = await retrieveUser(authenticatedUser.username, "");
            console.log("emailFriend=" + emailFriend);
            await UserService.addFriend(user.id, emailFriend)
                .then(d => {
                    setEmailFriend("");
                    setAddErrorMsg("");
                    getPublicPortfolio(followedUser);
                })
                .catch(err => {
                    console.log(err.message);
                    setAddErrorMsg("Email doesn't exist");
                });
        } else {
            console.log("username missing");
        }
        setIsEmailLoading(false);
    };

    const transferTRALE = async() => {
        const addressTRALE = `${process.env.REACT_APP_TRALE_ADDRESS}`;
        const abiTRALE = [{ "inputs": [], "payable": false, "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "spender", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Approval", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "previousOwner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "newOwner", "type": "address" }], "name": "OwnershipTransferred", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Transfer", "type": "event" }, { "constant": true, "inputs": [{ "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "address", "name": "spender", "type": "address" }], "name": "allowance", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "approve", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "balanceOf", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "decimals", "outputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "subtractedValue", "type": "uint256" }], "name": "decreaseAllowance", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "getOwner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "addedValue", "type": "uint256" }], "name": "increaseAllowance", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "mint", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "owner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [], "name": "renounceOwnership", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "totalSupply", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transfer", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "sender", "type": "address" }, { "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transferFrom", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "newOwner", "type": "address" }], "name": "transferOwnership", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }];

        const addressPlatform = `${process.env.REACT_APP_PAY_TO_ADDRESS}`;

        let web3;
        let currentAddr;

        let contractTRALE;

        if (window.ethereum) {
            web3 = new Web3(window.ethereum);

            try {
                //Connect again
                await window.ethereum.request({ method: "eth_requestAccounts" });
                //Get current connected account
                let accounts = await window.ethereum.request({ method: 'eth_accounts' });
                currentAddr = accounts[0];

                window.ethereum.on('chainChanged', (chainId) => {
                    window.location.reload();
                });

                var currNetworkID = await web3.eth.net.getId();
                if (currNetworkID == 56) { // BSC Mainnet
                    contractTRALE = await new web3.eth.Contract(abiTRALE, addressTRALE);

                    const currentTRALEBalance = await contractTRALE.methods.balanceOf(currentAddr).call();
                    if ((currentTRALEBalance / 1e18) < 88) {
                        alert("There is not enough 88 TRALE in current address");
                    } else {
                        contractTRALE.methods.transfer(addressPlatform, "88000000000000000000").send({ from: currentAddr },
                            function(error, transactionHash) {
                                if (error) {
                                    alert("Transaction failed");
                                } else {
                                    alert("Transaction successful");
                                    subscribe();
                                }
                            }
                        );
                    }
                } else {
                    // Request to change to mainnet
                    const data = [{
                        chainId: '0x38', //mainnet
                        //chainId: '0x61',
                        chainName: 'Binance Smart Chain',
                        nativeCurrency: {
                            name: 'BNB',
                            symbol: 'BNB',
                            decimals: 18
                        },
                        rpcUrls: ['https://bsc-dataseed.binance.org/'],
                        blockExplorerUrls: ['https://bscscan.com/'],
                    }];
                    /* eslint-disable */
                    const tx = await window.ethereum.request({ method: 'wallet_addEthereumChain', params: data }).catch();
                    if (tx) {
                        console.log(tx);
                    }
                }
            } catch (error) {
                console.error(error);
            }

        } else {
            alert("Please install Metamask first");
        }
    }

    return (
        <>
            <div className="tw-grid tw-grid-cols-1 sm:tw-flex sm:tw-items-center sm:tw-justify-between tw-px-2
                            sm:tw-px-4 lg:tw-pr-20 lg:tw-pl-10 tw-pb-4 lg:tw-pb-8">
                <span className="tw-text-4xl tw-font-extrabold tw-text-gray-500 dark:tw-text-light">Portfolio of {followedUser}</span>
            </div>

            <>
                {isLoading && <div className="tw-text-center tw-py-20"><Loader /></div>}

                {errorMessage && errorMessage.length > 0 &&
                <div className="tw-text-center tw-text-lg tw-py-20 tw-pl-10 tw-pr-20">
                    {errorMessage}
                    <br /><br />
                    {errorStatus && errorStatus !== 404 && followedUser &&


                    <ul className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-8">
                        <li>
                            <div
                                className={`hover:tw-border-yellow-500 hover:tw-shadow-lg tw-group tw-block tw-rounded-lg tw-border tw-border-gray-200`}>
                                <span className="tw-text-red-600"> {addErrorMsg} </span>
                                <dl className="tw-grid tw-items-center">
                                    <form onSubmit={handleAddFriend} className="tw-w-full">
                                        <div className="tw-p-4">
                                            <dt className="tw-sr-only">Add email</dt>
                                            <dd className="group-hover:tw-text-gray-400 tw-leading-6 tw-text-2xl tw-font-medium">
                                                Add email
                                            </dd>
                                        </div>
                                        <div className="tw-p-4 tw-mb-4">
                                            <input
                                                className="tw-w-full tw-px-4 tw-py-2 tw-border tw-rounded-md dark:tw-bg-darker dark:tw-border-gray-700 focus:tw-outline-none focus:tw-ring focus:tw-ring-primary-100 dark:tw-focus:ring-primary-darker"
                                                type="email"
                                                id="emailFriend"
                                                name="emailFriend"
                                                placeholder="Email"
                                                value={emailFriend}
                                                onChange={(e) => setEmailFriend(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <div>
                                            <dt className="tw-sr-only">Subscribe</dt>
                                            <dd className="tw-px-4 tw-py-4 tw-bg-gray-50 tw-text-right sm:tw-px-6 dark:tw-border-t tw-rounded-b-lg dark:tw-border-primary-dark dark:tw-bg-darker tw-mb-0">
                                                <LoaderButton isLoading={isEmailLoading}
                                                              className="tw-inline-flex tw-justify-center tw-w-full sm:tw-ml-3 sm:tw-w-auto sm:tw-text-sm tw-px-4 tw-py-2 tw-font-medium tw-text-center tw-text-white tw-transition-colors tw-duration-200 tw-rounded-md tw-bg-primary hover:tw-bg-primary-dark"
                                                >Add</LoaderButton>
                                            </dd>

                                        </div>
                                    </form>
                                </dl>
                            </div>
                        </li>
                        {/*<li>*/}
                        {/*    <div*/}
                        {/*        className={`hover:tw-border-yellow-500 hover:tw-shadow-lg tw-group tw-block tw-rounded-lg tw-border tw-border-gray-200`}>*/}
                        {/*        <dl className="tw-grid tw-items-center">*/}
                        {/*            <div className="tw-p-4">*/}
                        {/*                <dt className="tw-sr-only">Credit card</dt>*/}
                        {/*                <dd className="group-hover:tw-text-gray-400 tw-leading-6 tw-text-2xl tw-font-medium">*/}
                        {/*                    Credit card*/}
                        {/*                </dd>*/}
                        {/*            </div>*/}
                        {/*            <div className="tw-p-4 tw-mb-4">*/}
                        {/*                <dt className="tw-sr-only">Price</dt>*/}
                        {/*                <dd className="group-hover:tw-text-gray-400 tw-text-sm tw-font-medium">*/}
                        {/*                    <span className="tw-text-2xl tw-font-medium">$10.00</span>*/}
                        {/*                    <br />per month*/}
                        {/*                    <br />to follow him*/}
                        {/*                </dd>*/}
                        {/*            </div>*/}
                        {/*            <div>*/}
                        {/*                <dt className="tw-sr-only">Subscribe</dt>*/}
                        {/*                <dd className="tw-px-4 tw-py-4 tw-bg-gray-50 tw-text-right sm:tw-px-6 dark:tw-border-t tw-rounded-b-lg dark:tw-border-primary-dark dark:tw-bg-darker tw-mb-0">*/}
                        {/*                    <LoaderButton onClick={subscribe}*/}
                        {/*                                  isLoading={isBtnLoading}*/}
                        {/*                                  className="tw-inline-flex tw-justify-center tw-w-full sm:tw-ml-3 sm:tw-w-auto sm:tw-text-sm tw-px-4 tw-py-2 tw-font-medium tw-text-center tw-text-white tw-transition-colors tw-duration-200 tw-rounded-md tw-bg-primary hover:tw-bg-primary-dark"*/}
                        {/*                    >Subscribe</LoaderButton>*/}
                        {/*                </dd>*/}

                        {/*            </div>*/}
                        {/*        </dl>*/}
                        {/*    </div>*/}
                        {/*</li>*/}
                        <li>
                            <div
                                className={`hover:tw-border-yellow-500 hover:tw-shadow-lg tw-group tw-block tw-rounded-lg tw-border tw-border-gray-200`}>
                                <dl className="tw-grid tw-items-center">
                                    <div className="tw-p-4">
                                        <dt className="tw-sr-only">TRALE Token</dt>
                                        <dd className="group-hover:tw-text-gray-400 tw-leading-6 tw-text-2xl tw-font-medium">
                                            Token
                                        </dd>
                                    </div>
                                    <div className="tw-p-4 tw-mb-4">
                                        <dt className="tw-sr-only">Price</dt>
                                        <dd className="group-hover:tw-text-gray-400 tw-text-sm tw-font-medium">
                                            <span className="tw-text-2xl tw-font-medium">100 Tokens</span>
                                            <br />per month
                                            <br />to follow him
                                        </dd>
                                    </div>
                                    <div>
                                        <dt className="tw-sr-only">Subscribe</dt>
                                        <dd className="tw-px-4 tw-py-4 tw-bg-gray-50 tw-text-right sm:tw-px-6 dark:tw-border-t tw-rounded-b-lg dark:tw-border-primary-dark dark:tw-bg-darker tw-mb-0">
                                            <LoaderButton onClick={transferTRALE}
                                                          isLoading={isBtnLoading}
                                                          className="tw-inline-flex tw-justify-center tw-w-full sm:tw-ml-3 sm:tw-w-auto sm:tw-text-sm tw-px-4 tw-py-2 tw-font-medium tw-text-center tw-text-white tw-transition-colors tw-duration-200 tw-rounded-md tw-bg-primary hover:tw-bg-primary-dark"
                                            >Subscribe</LoaderButton>
                                        </dd>
                                    </div>
                                </dl>
                            </div>
                        </li>
                    </ul>

                    }
                </div>}

                {isAuthenticated && authenticatedUser && dataRows && dataRows.length > 0 &&
                <div
                    className="tw-grid tw-grid-cols-1 tw-p-4 tw-pt-8 tw-px-2 sm:tw-px-4 lg:tw-pl-10 lg:tw-pr-20">
                    { urlParams && urlParams.get("from") === "sub" &&
                        <div className="tw-text-right tw-py-4">
                            <LoaderButton onClick={unsubscribe}
                                          isLoading={isBtnLoading}
                                    className="tw-mt-3 sm:tw-mt-0 sm:tw-ml-3 sm:tw-w-auto sm:tw-text-sm tw-inline-flex tw-justify-center tw-rounded-md border tw-border-gray-300 tw-px-4 tw-py-2 tw-bg-white tw-text-base tw-font-medium tw-text-gray-700 hover:tw-bg-gray-50 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2 focus:tw-ring-indigo-500">
                                Unsubscribe
                            </LoaderButton>
                        </div>
                    }
                    <PortfolioPublicTable dataRows={dataRows} />
                </div>

                }


            </>
        </>
    );
}